var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.51687 3.12932C5.71827 2.92792 6.03534 2.92792 6.23674 3.12932C6.43133 3.32392 6.43133 3.64779 6.23674 3.84193L2.58661 7.49206H14.6315C14.9123 7.49206 15.1427 7.71523 15.1427 7.99601C15.1427 8.27679 14.9123 8.50722 14.6315 8.50722H2.58661L6.23674 12.1505C6.43133 12.3519 6.43133 12.6763 6.23674 12.8704C6.03534 13.0718 5.71827 13.0718 5.51687 12.8704L1.00264 8.35617C0.808041 8.16157 0.808041 7.8377 1.00264 7.64356L5.51687 3.12932Z",
    fill: "#2196F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2857,
    height: 14.2857,
    fill: "white",
    transform: "translate(0.856934 0.857178)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.a41355067f217871a0019438d2aacb29.svg";
export { ForwardRef as ReactComponent };